// extracted by mini-css-extract-plugin
export default {"item":"_9a0f2f95"};